import Aclaracion from "../interfaces/Aclaracion.interface";
import Fecha from "../tools/Fecha.tool";



const getEstructura = () => {
    const aclaracion: Aclaracion = {
        IdAclaracion: 0,
        denominacion: "Sinergia Financiera de México, S.A. de C.V., SOFOM, E.N.R.",
        sector: "Sociedades Financieras de Objeto Múltiple E.N.R.",
        trimestre: Fecha.getNomTrimestre(),
        numero: 1,
        folioAtencion: "",
        estadoConPend: 0,
        fechaAclaracion: Fecha.getDateToDay(),
        fechaAtencion: Fecha.getDateToDay(),
        medioRecepcionCanal: 5,
        productoServicio: "",
        causaMotivo: "",
        fechaResolucion: Fecha.getDateToDay(),
        fechaNotifUsuario: Fecha.getDateToDay(),
        entidadFederativa: 0,
        codigoPostal: 0,
        municipioAlcaldia: 0,
        localidad: 0,
        colonia: "null",
        monetario: "NO",
        montoReclamado: 0,
        pori: "null",
        tipoPersona: 0,
        sexo: "null",
        edad: 0,
        nivelAtencion: 0,
        folioCondusef: "",
        reversa: 0,
        operacionExtranjero: "NO",
    };
    return aclaracion;
}

const validar = (reclamo: Aclaracion): { value: boolean, arrayErrors: string[] } => {
    let value: boolean = false;
    let arrayErrors: string[] = [];

    if (reclamo.folioAtencion.length === 0) { value = true; arrayErrors.push("Falta especificar el folio") };
    if (reclamo.estadoConPend === 0) { value = true; arrayErrors.push("Falta especificar el estatus") };
    if (reclamo.medioRecepcionCanal === 0) { value = true; arrayErrors.push("Falta especificar el medio de recepción o canal") };
    if (reclamo.productoServicio.length === 0) { value = true; arrayErrors.push("Falta especificar el producto") };
    if (reclamo.causaMotivo.length === 0) { value = true; arrayErrors.push("Falta especificar la causa del producto") };
    if (reclamo.entidadFederativa === 0) { value = true; arrayErrors.push("Falta especificar el estado"); }
    if (reclamo.codigoPostal === 0) { value = true; arrayErrors.push("Falta especificar el código postal"); }
    if (reclamo.municipioAlcaldia === 0) { value = true; arrayErrors.push("Falta especificar la ciudad"); }
    if (reclamo.localidad === 0) { value = true; arrayErrors.push("Falta especificar la localidad"); }
    if (reclamo.monetario === "null") { value = true; arrayErrors.push("Falta especificar si es monetario"); }
    if (reclamo.pori === "null") { value = true; arrayErrors.push("Falta especificar el PORI"); }
    if (reclamo.tipoPersona === 0) { value = true; arrayErrors.push("Falta especificar el tipo de persona"); }
    if (reclamo.tipoPersona === 1 && reclamo.sexo === "null") { value = true; arrayErrors.push("Falta especificar el sexo"); }
    if (reclamo.tipoPersona === 1 && reclamo.edad === 0) { value = true; arrayErrors.push("Falta especificar la edad"); }
    if (reclamo.tipoPersona === 1 && reclamo.edad < 18) { value = true; arrayErrors.push(`La edad tiene que ser mayor o igual a 18, escribió ${reclamo.edad}`); }
    if (reclamo.nivelAtencion === 0 && reclamo.estadoConPend === 2) { value = true; arrayErrors.push("Falta especificar el nivel de atención"); }

    return { value, arrayErrors };
}


const AclaracionModel = {
    getEstructura,
    validar,
}

export default AclaracionModel